export class News {
  constructor(id, heading, newstext, image, date) {
    this.id = id;
    this.heading = heading;
    this.newstext = newstext;
    this.image = image;
    this.date = date;
  }
}
